(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[89149,52892],{

/***/ 77936:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/ccpa-privacy-notice",
      function () {
        return __webpack_require__(57765);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SeveralBrandsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73191);
/* harmony import */ var _components_shared_legal_ccpaPrivacyNotice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66699);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66405);
/* harmony import */ var _components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54531);
/* harmony import */ var _components_severalbrands_legal_style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62617);
/* harmony import */ var _components_severalbrands_legal_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_severalbrands_legal_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var __N_SSG = true;
function SeveralBrandsHome({ domain  }) {
    const metaTags = (0,_components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_5__/* .getMetaTitleDescriptionForPage */ .Z5)(domain, "CcpaPrivacyNotice");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        domainInfo: domain,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: metaTags?.title ?? "Privacy Notice for California Residents | SeveralBrands.com",
                description: metaTags?.description ?? "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.",
                keyWords: (0,_components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_5__/* .getKeyWordsForMetaTags */ .U8)(domain)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_legal_ccpaPrivacyNotice__WEBPACK_IMPORTED_MODULE_3__["default"], {
                mainWrapperClassName: (_components_severalbrands_legal_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainContainer)
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,66699,81711,79011,49774,92888,40179], function() { return __webpack_exec__(77936); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);